namespace Gamification.Gamification {
    export interface ApiRow {
        IdApi?: number;
        Nome?: string;
        Descrizione?: string;
    }

    export namespace ApiRow {
        export const idProperty = 'IdApi';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.Api';
        export const lookupKey = 'Gamification.Api';

        export function getLookup(): Q.Lookup<ApiRow> {
            return Q.getLookup<ApiRow>('Gamification.Api');
        }
        export const deletePermission = 'Gamification:Configurazione';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdApi = "IdApi",
            Nome = "Nome",
            Descrizione = "Descrizione"
        }
    }
}
